import { render } from "./SalesPointsDetail.vue?vue&type=template&id=3ca4d42b"
import script from "./SalesPointsDetail.vue?vue&type=script&lang=js"
export * from "./SalesPointsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__